/** Marks a scrolling box `has-more` while part of its content lies below its bottom edge; the CSS
 *  fades the last line there, so a cut-off popup, sheet or list reads as "more below". Only its
 *  bottom padding out of sight cuts nothing. */
export function hintMoreBelow(box: HTMLElement): void {
  const update = (): void => {
    const below = box.scrollHeight - box.scrollTop - box.clientHeight;
    box.classList.toggle('has-more', below - parseFloat(getComputedStyle(box).paddingBottom) > 2);
  };
  box.addEventListener('scroll', update, { passive: true });
  // a photo that arrives late makes the content taller (load does not bubble: capture)
  box.addEventListener('load', update, true);
  // the content can change without the box changing size (a box that fills its room, or one at its
  // height cap): the size of each child counts too, and so does a child put in or taken out
  const resized = new ResizeObserver(update);
  resized.observe(box);
  for (const child of box.children) resized.observe(child);
  new MutationObserver((records) => {
    for (const { addedNodes, removedNodes } of records) {
      for (const node of removedNodes) if (node instanceof Element) resized.unobserve(node);
      for (const node of addedNodes) if (node instanceof Element) resized.observe(node);
    }
    update();
  }).observe(box, { childList: true });
  update();
}
